import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { OverlayListenerOptions, OverlayOptions } from 'primeng/api';
import { CARE_OPTIONS, CareCondition, NUTRITION_OPTIONS, NutritionCondition, TEMPERAMENT_OPTIONS, TemperamentCondition } from 'src/app/modules/animals/models/body-condition-score.model';

@Component({
  selector: 'app-body-condition-score',
  templateUrl: './body-condition-score.component.html',
  styleUrls: ['./body-condition-score.component.scss'],
  standalone: false
})
export class BodyConditionScoreComponent {
  @Input({ required: true }) careCtrl!: AbstractControl<CareCondition[] | null>;
  @Input({ required: true }) nutritionCtrl!: AbstractControl<NutritionCondition | null>;
  /** Optional: ohne Control wird die Spalte „Wesen“ ausgeblendet (z. B. in der Karteikarte). */
  @Input() temperamentCtrl: AbstractControl<TemperamentCondition[] | null> | null = null;
  careOptions = CARE_OPTIONS;
  nutritionOptions = NUTRITION_OPTIONS;
  temperamentOptions = TEMPERAMENT_OPTIONS;

  selectedCare: CareCondition[] = [];
  selectedNutrition: NutritionCondition | null = null;
  selectedTemperament: TemperamentCondition[] = [];
  mediaDialogVisible = false;

  readonly dropdownOverlayOptions: OverlayOptions = {
    listener: (_event: Event, options?: OverlayListenerOptions): boolean =>
      options?.type === 'scroll' ? false : (options?.valid ?? true),
  };

  @Output() changed = new EventEmitter<{
    care: CareCondition[];
    nutrition: NutritionCondition | null;
    temperament: TemperamentCondition[];
  }>();

  emitChanges() {
    this.changed.emit({
      care: this.selectedCare,
      nutrition: this.nutritionCtrl.value,
      temperament: this.selectedTemperament
    });
  }

  getCareLabel(value: CareCondition): string {
    return this.careOptions.find(o => o.value === value)?.label ?? value;
  }

  getNutritionLabel(value: NutritionCondition): string {
    return this.nutritionOptions.find(o => o.value === value)?.label ?? value;
  }

  getTemperamentLabel(value: TemperamentCondition): string {
    return this.temperamentOptions.find(o => o.value === value)?.label ?? value;
  }

  getCareDescription(value: CareCondition): string {
    return this.careOptions.find(o => o.value === value)?.description ?? value;
  }

  getNutritionDescription(value: NutritionCondition): string {
    return this.nutritionOptions.find(o => o.value === value)?.description ?? value;
  }

  getTemperamentDescription(value: TemperamentCondition): string {
    return this.temperamentOptions.find(o => o.value === value)?.description ?? value;
  }

  get careInvalid(): boolean {
    return this.careCtrl.invalid;
  }
  get nutritionInvalid(): boolean {
    return !!this.nutritionCtrl.invalid;
  }
  get temperamentInvalid(): boolean {
    return !!this.temperamentCtrl?.invalid;
  }
  openMediaDialog(): void {
    this.mediaDialogVisible = true;
  }

  closeMediaDialog(): void {
    this.mediaDialogVisible = false;
  }
}